<template>
  <div>
    <nuxt-page />
  </div>
</template>
